import "jquery-match-height";
// import Swiper JS
// import Swiper from 'swiper';
// import Swiper styles
// import 'swiper/swiper-bundle.css';

var header = $('.user-menu');
var width = $(window).width();
var height = $( window ).height();
// var sticky = header.offsetTop;

function scrollFuction() {
  if (window.pageYOffset > 20) {
    header.addClass('top-0');
    $('.front .user-menu').addClass('top-0 shrink');
  } else {
    $('.front .user-menu').removeClass('top-0 shrink')
  }
}

function responsive() {
  var height = $( window ).height();
  var width = $(window).width();
  var maxHeight = height - 30;
  if(width > 991) {
    $('.user-menu .dropdown-toggle').removeAttr('data-toggle');
    // if($('.sns-list .cart-menu').length){
    //   $('.cart-menu').not('.cart-menu:first').remove();
    // }
    // else{
    //   $('.cart-menu').insertAfter('.sns-list > li:last-child');
    // }
    $('header').removeClass('fixed-top-sp')
    // $('.header .social-media-block').insertBefore('.main-menu');

    // $('.user-menu .nav-item.dropdown .dropdown-menu').removeClass('d-block')

    // $('.header').css({
    //   'max-height': 'initial',
    //   'overflow-y': 'auto'
    // });

    // search
    // $('.search-holder').prependTo('.main-nav .first-nav .search-container.search-item');

    // search icon
    $('.user-menu .sp-menu .menu-main-menu .top-logos .search-btn').prependTo('.user-menu .mobile-left');

    // header login
    $('.user-menu  .sp-menu .menu-main-menu .cart-login').prependTo('.user-menu .social-media-block .sns-list .bottom-logos');

    // header icons
    $('.user-menu .sp-menu .menu-main-menu .top-logos').appendTo('.user-menu .social-media-block .sns-list');

    // tab social
    $('.social--tabs li.social-item').removeClass('swiper-slide');
    $('.block-tabs .prod-tabs li.social-item').prependTo('.block-tabs .social--tabs');

    // dropdown
    if($('.user-menu .nav-item.dropdown .dropdown-menu').hasClass('show')) {
      $('.user-menu .nav-item.dropdown .dropdown-menu').removeClass("show");
    };

    // search-input filled
    $(".search-input").focus(function(){
      $(this).parent().removeClass("input-filled");
      $(this).parent().addClass("input-focus");

    }).blur(function(){
        $(this).parent().removeClass("input-focus");
        $(this).parent().addClass("input-filled");
    });

    $('.tab--container').addClass('swiper-no-swiping');
  }
  else {

    $('.user-menu .dropdown-toggle').removeAttr('data-toggle', 'dropdown');
    // $('.header .social-media-block').insertAfter('.user-menu .navbar-brand')

    // $('.cart-menu').not('.cart-menu:first').remove();
    //   if($('.navbar-header .cart-menu').length){
    //     // console.log('cart');
    //     $('.cart-menu').not('.cart-menu:first').remove();
    //   }
    //   else{
    //     $('.cart-menu').insertAfter('.navbar-brand');
    //   }

    // $('.header .nav-item.dropdown .dropdown-menu').addClass('d-block');

    // $('.header').css({
    //   'max-height': maxHeight,
    //   'overflow-y': 'auto'
    // })
    // console.log(height)

    // $('.search-holder').appendTo('.search-mobile');

    // header login
    $('.user-menu .social-media-block .sns-list .bottom-logos .cart-login').prependTo('.user-menu .sp-menu .menu-main-menu');

    // header icons
    $('.user-menu .social-media-block .sns-list .top-logos').prependTo('.user-menu .sp-menu .menu-main-menu');

    // search icon
    $('.user-menu .mobile-left .search-btn').prependTo('.user-menu .sp-menu .menu-main-menu .top-logos');

    // tab social
    $('.social--tabs li.social-item').addClass('swiper-slide');
    $('.block-tabs .social--tabs .social-item').appendTo('.block-tabs .prod-tabs');

    // side-menu dropdown
    $('.user-menu .navbar-collapse .dropdown').each( function() {
      var menu = $('> a', this);
      var submenu = $('.dropdown-menu', this);

      menu.one("click", function(e) {
        e.preventDefault();
        submenu.addClass("show");

        return false;
      });
    });

    // prod tabs
    $('.tab--container').removeClass('swiper-no-swiping');
    var swiper = new Swiper('.tab--container', {
      slidesPerView: 'auto',
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
    });
  }

  // if(width <= 991 && width >= 575 ) {
  //   $('.header .social-media-block').insertAfter('.user-menu .navbar-brand');
  // }
  // else {
  //   $('.header .social-media-block').insertBefore('.header .main-menu');
  // }

  // basket
  // if (width <= 575) {
  //   $('.user-menu .cart-menu').insertAfter('.header .navbar-brand');
  //   // $('.header .social-media-block').insertAfter('.user-menu .navbar-header');
  //   $('.user-menu .sns-list .cart-menu').not('.user-menu .cart-menu:first').remove();
  //   // $('.summary--block .qty-item').insertAfter('.summary--block .author');
  // }
  // else {
  //   $('.user-menu .cart-menu').insertAfter('.user-menu .sns-list > li:last-child');
  //   $('.user-menu .sns-list .cart-menu').not('.user-menu .cart-menu:first').remove();
  //   // $('.header .social-media-block').insertAfter('.header .navbar-brand');
  // }

  // if(width >= 992) {
  //   $('.header .social-media-block').insertBefore('.header .main-menu');
  // }

    // var total = $('.cart .item > .total');
    // console.log($('.cart .cart-item').length)

    // $('.cart .cart-item').each( function (i) {
    //   var total = $('.total', this);
    //   var variant = $('.variant', this)
    //   var remove = $('.remove', this)
    //   var qty = $('.qty-wrapper', this)
    //   var details_wrapper = $('.details-wrapper', this)
    //   // console.log(author)
    //   if(width <= 575) {
    //     // total.insertAfter(variant).addClass('sp');
    //     // remove.insertAfter(total).addClass('sp');

    //     remove.appendTo(details_wrapper);
    //   }
    //   else {
    //     // total.insertAfter(author).remove();
    //     // remove.insertAfter(total).remove();
    //     // $('.sp').remove();

    //     // total.insertAfter(qty);
    //     // remove.insertAfter(total);

    //     remove.insertAfter(details_wrapper);
    //   }
    // });

    $('.summary--block .item').each( function() {
      var qty = $('.qty-item', this);
      var author = $('.author', this);
      var total = $('.total-item', this);
      var details = $('.details-item', this);

      if(width <= 575) {
        qty.insertAfter(author).addClass('sp');
        total.insertAfter(qty).addClass('sp');
      }
      else {
        qty.insertAfter(details);
        total.insertAfter(qty);
      }
    });

}
$('document').ready(function () {
  responsive();
  lazySizes.init();
  // $("body,html").animate({
  //   scrollTop: 0 // Scroll to top of body
  // }, 800);

  // promo-header
  $('.promo-close').click(function() {
    $(".promo-header").removeClass("show");
    $(".main-wrapper").addClass("wo-promo");
  });

  $('.item-list > .item--title').matchHeight();
  $('.book p').each(function(){
    $(this).html($(this).html().replace(/&nbsp;/gi," "));
  });
  $('.events.page p').each(function() {
    var $this = $(this);
    if($this.html().replace(/\s|&nbsp;/g, '').length == 0)
        $this.remove();
  });

  window.onscroll = function() {scrollFuction()};
  // function scrollFunction()
  $(window).scroll(function () {
    if ($(this).scrollTop() >= 100) {
      $('.front .user-menu').addClass('fixed-top');
      // If page is scrolled more than 50px
      $(".scrollbutton").fadeIn(100).addClass("fadeInUp").removeClass("fadeOutDown"); // Fade in the arrow
    } else {
      $('.front .user-menu').removeClass('fixed-top');
      $(".scrollbutton").fadeOut(200).addClass("fadeOutDown").removeClass("fadeInUp"); // Else fade out the arrow
    }
  });
  $(".scrollbutton").click(function () {
    // When arrow is clicked
    $("body,html").animate({
      scrollTop: 0 // Scroll to top of body
    }, 1000);
  });


var headerContainer = $('.user-menu');
var topPanel = headerContainer.find('.main-menu');
var searchHolder = headerContainer.find('.search-holder');
var searchForm = headerContainer.find('#search-form');
var openToggle = headerContainer.find('.search-toogle');
var closeToggle = searchForm.find('#form-close');

function calculateAnimationProps () {
  var vpWidth = $(window).outerWidth(true);
  var width = 0;

  if (vpWidth < 1000) {
    width = headerContainer.outerWidth(true) - 15; // Minus container side padding
  } else {
    width = topPanel.outerWidth(true);
  }

  var right = width - openToggle.outerWidth(true);

  return {
    formWidth: width,
    formRight: right,
    toggleRight: right / 2
  };
}

  // Show search form
  $('.search-toogle').on('click', function() {
    var animProps = calculateAnimationProps();

    searchHolder.show().css({
      width: animProps.formWidth,
      height: headerContainer.outerHeight(true)
    });

    searchForm.css({
      width: animProps.formWidth,
      right: -(animProps.formRight),
      transform: 'translatex(-' + animProps.formRight + 'px)'
    }).addClass('active');

    $(this).css({
      right: animProps.toggleRight,
      transform: 'translatex(-' + animProps.toggleRight + 'px)'
    }).addClass('hidden');
  });

  // Hide search form
  closeToggle.on('click', function() {
    searchForm.css('transform', '')
      .removeClass('active');

    // Let the animation finished first then hide the holder
    setTimeout(function () {
      searchHolder.hide();
    }, 500);

    openToggle.removeAttr('style')
      .removeClass('hidden');
  });

  $(window).on('resize', function(){
    responsive();
  });

  $('.navbar-toggler').on('click', function() {
    // console.log('click')
    // $('body').addClass('o-hidden');
    if($('body').hasClass('o-hidden open-sidenav')) {
      $('body').removeClass('o-hidden open-sidenav');
      $('#scrollTopBtn').removeClass('invisible');
    }
    else {
      $('body').addClass('o-hidden open-sidenav');
      $('#scrollTopBtn').addClass('invisible');
    }
  });

  $(document).click(function (event) {
    var clickover = $(event.target);
    var _opened = $(".navbar-collapse").hasClass("show");
    if (_opened === true && !clickover.hasClass("navbar-toggler")) {
        $("button.navbar-toggler").click();
        $('body').removeClass('o-hidden open-sidenav');
    }
  });

  $('.custom-file-input.profile-upload').change(function(){
    var value = $('.custom-file-input.profile-upload').val();
    var m = value.match(/([^\/\\]+)$/);
    var value = m[1];
    // console.log(value.length);
    if(value.length >= 30) {
      $('.custom-file-label.profile-label').text(value.substring(0,30) + '...');
    }
    else {
      $('.custom-file-label.profile-label').text(value);

    }
  });
  $('.custom-file-input.cover-upload').change(function(){
    var value = $('.custom-file-input.cover-upload').val();
    var m = value.match(/([^\/\\]+)$/);
    var value = m[1];
    // console.log(value);
    if(value.length >= 30) {
      $('.custom-file-label.cover-label').text(value.substring(0,30) + '...');
    }
    else {
      $('.custom-file-label.cover-label').text(value);

    }
  });
  $('.custom-file-input.file-upload').change(function(){
    var value = $('.custom-file-input.file-upload').val();
    var m = value.match(/([^\/\\]+)$/);
    var value = m[1];
    // console.log(value);
    if(value.length >= 30) {
      $('.custom-file-label.file-label').text(value.substring(0,30) + '...');
    }
    else {
      $('.custom-file-label.file-label').text(value);

    }
  });

  // homepage category

  // $('.block-home-category .category-slider').slick({
  //   infinite: true,
  //   slidesToShow: 4,
  //   slidesToScroll: 4,
  //   autoplay: true,
  //   autoplaySpeed: 2000,
  //   prevArrow: '<button class="slick-prev"><i class="fa fa-chevron-left" aria-hidden="true"></i></button>',
  //   nextArrow: '<button class="slick-next"><i class="fa fa-chevron-right" aria-hidden="true"></i></button>'
  // });
  var swiper = new Swiper('.block-home-category .swiper-container', {
    slidesPerView: 1.5,
    spaceBetween: 30,
    centeredSlides: true,
    loop: true,
    preloadImages: false,
    lazy: true,
    // lazy: {
    //   loadPrevNext: true,
    // },
    navigation: {
      nextEl: '.swiper-button-next-custom',
      prevEl: '.swiper-button-prev-custom',
    },
    breakpoints: {
      // when window width is <= 576px
      576: {
        slidesPerView: 2,
        spaceBetweenSlides: 20,
        centeredSlides: false,
      },
      // when window width is <= 992px
      992: {
        slidesPerView: 4,
        spaceBetweenSlides: 80,
        centeredSlides: false,
      }
    },

  });

  var swiper = new Swiper('.block-testimonials .swiper-container', {
    slidesPerView: 1.3,
    spaceBetween: 20,
    centeredSlides: true,
    loop: true,
    preloadImages: false,
    lazy: true,
    watchSlidesVisibility: true,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    breakpoints: {
      // when window width is <= 576px
      // 576: {
      //   slidesPerView: 2,
      //   spaceBetweenSlides: 40
      // },
      // when window width is <= 992px
      992: {
        slidesPerView: 2,
        spaceBetween: 80
      }
    },
  });

  // destroy swiper when mobile
  // 'use strict';

  // // breakpoint where swiper will be destroyed
  // // and switches to a dual-column layout
  // const breakpoint = window.matchMedia( '(max-width:991px)' );

  // // keep track of swiper instances to destroy later
  // let mySwiper;

  // //////////////////////////////////////////////////////////////////
  // //////////////////////////////////////////////////////////////////
  // //////////////////////////////////////////////////////////////////

  // const breakpointChecker = function() {

  //   // if larger viewport and multi-row layout needed
  //   if ( breakpoint.matches === true ) {

  //     // clean up old instances and inline styles when available
	//   if ( mySwiper !== undefined ) mySwiper.destroy( true, true );

	//   // or/and do nothing
	//   return;

  //     // else if a small viewport and single column layout needed
  //     } else if ( breakpoint.matches === false ) {

  //       // fire small viewport version of swiper
  //       return enableSwiper();

  //     }

  // };

  // //////////////////////////////////////////////////////////////////
  // //////////////////////////////////////////////////////////////////
  // //////////////////////////////////////////////////////////////////

  // const enableSwiper = function() {
    var mySwiper = new Swiper('.block-feature .swiper-container', {
      slidesPerView: 1,
      spaceBetween: 20,
      preloadImages: false,
      lazy: true,
      watchSlidesVisibility: true,
      autoplay: {
        delay: 5000,
      },
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
    });
  // };

  // //////////////////////////////////////////////////////////////////
  // //////////////////////////////////////////////////////////////////
  // //////////////////////////////////////////////////////////////////

  // // keep an eye on viewport size changes
  // breakpoint.addListener(breakpointChecker);

  // // kickstart
  // breakpointChecker();

  // end destroy swiper when mobile

  $('.cookies-x').click(() => {
    $('.pop-cookies').hide();
    document.cookie = '_accepts-cookies=true';
  });

  // password
  $('.toggle-password').click(function(){
    $pass = $(this).closest($('.form-group')).find($('.password-field'));
    if( $(this).hasClass('show') ) {
        $pass.attr('type','password');
        $(this).removeClass('show');
        // console.log($pass);
    } else {
        $pass.attr('type','text');
        $(this).addClass('show');
        // console.log($pass);
    }
  });

  // prod tabs
  $('.prod-tabs i.fa').click(function() {
    $(this).parent().toggleClass('open');
  });

  $('.prod-tabs > li a').click(function() {
    $('.prod-tabs > li').removeClass('active');
    $(this).parent().addClass('active');
    $('.prod-tabs').toggleClass('open');
  });

  // Initialize the gallery
  // $('#testimonial-slider a').touchTouch();

  // $('#blog-inner a').touchTouch();


  // // Get the modal
  // var modal = document.getElementById('myModal');

  // // Get the image and insert it inside the modal - use its "alt" text as a caption
  // var img = document.getElementById('myImg');
  // var modalImg = document.getElementById("img01");
  // img.onclick = function(){
  //     modal.style.display = "block";
  //     modalImg.src = this.src;
  // }

  // // Get the <span> element that closes the modal
  // var span = document.getElementsByClassName("close")[0];

  // // When the user clicks on <span> (x), close the modal
  // span.onclick = function() {
  //     modal.style.display = "none";
  // }

  if ($('#gallerySlider .placeholder').length <= 1) {
    $('#prevArrow').addClass("d-none");
    $('#nextArrow').addClass("d-none");
  }

    // search
    $('.user-menu .main-nav .search-btn').click(function() {
      if ($(".search-mobile").hasClass("show")) {
        $(".search-mobile").removeClass("show");
      }
      else {
        $(".search-mobile").addClass("show");
      }
    });

  // yt banner
	loadScript();
	loadPlayer();

	function loadScript() {
		if (typeof(YT) == 'undefined' || typeof(YT.Player) == 'undefined') {
			var tag = document.createElement('script');
			tag.src = "https://www.youtube.com/iframe_api";
			var firstScriptTag = document.getElementsByTagName('script')[0];
			firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
		}
	}

	function loadPlayer() {
			window.onYouTubePlayerAPIReady = function() {
				onYouTubePlayer();
				var player;

				function onYouTubePlayer() {
				  player = new YT.Player('player', {

					events: {
					  'onReady': function (e) {
              e.target.mute();
              e.target.setVolume(50);
              console.log("here");
            },
					  'onStateChange': function (e) {
              if (e.data == YT.PlayerState.PLAYING && !done) {
                  setTimeout(e.target.setVolume(50), 5000);
                  done = true;
              }
            }
					}

				  });
        }

			};
  }

  ( function() {
    var youtube = document.querySelectorAll( ".youtube" );
    var player;

    for (var i = 0; i < youtube.length; i++) {
      var source = "https://img.youtube.com/vi/"+ youtube[i].dataset.embed +"/sddefault.jpg";
      var image = new Image();
      image.src = source;
      image.addEventListener("load", function () {
        youtube[i].appendChild( image );
      }(i));

      youtube[i].addEventListener("click", function () {
        // console.log('starting player')
        var iframe = document.createElement( "iframe" );

        iframe.setAttribute( "class", "yt-player" );
        iframe.setAttribute( "id", "yt-player" );
        iframe.setAttribute( "frameborder", "0" );
        iframe.setAttribute( "allowfullscreen", "" );
        iframe.setAttribute( "src", "https://www.youtube.com/embed/"+ this.dataset.embed +"?autoplay=1&rel=0&enablejsapi=1" );

        this.innerHTML = "";
        this.appendChild( iframe );

        player = new YT.Player('yt-player', {
					events: {
            'onStateChange': function (e) {
              switch (e.data) {
                case YT.PlayerState.ENDED:
                  $('.home-banner').slick('slickPlay');
                  $('.back-banner').slick('slickPlay');
                  break;
                case YT.PlayerState.PLAYING:
                  $('.home-banner').slick('slickPause');
                  $('.back-banner').slick('slickPause');
                  break;
                case YT.PlayerState.PAUSED:
                  $('.home-banner').slick('slickPlay');
                  $('.back-banner').slick('slickPlay');
                  break;
              }
            }
					}
        });
      });
    };

  } )();

  // move breadcrumb inside background
  $('.shop.node-show .breadcrumbs').prependTo('.shop.node-show .product--header')

  // add show on panel-items
  $('.panel-item .panel-collapse').on('shown.bs.collapse', function () {
    $(this).parent().addClass('show');
  });

  $('.panel-item .panel-collapse').on('hidden.bs.collapse', function () {
    $(this).parent().removeClass('show');
  });

  // add show on panel-main
  $('.panel-main .panel-group-collapse').on('shown.bs.collapse', function () {
    $(this).parent().addClass('show');
  });

  $('.panel-main .panel-group-collapse').on('hidden.bs.collapse', function () {
    $(this).parent().removeClass('show');
  });

  $('#product--faq, #product--feature, #product--articles').appendTo('.shop.node-show .product > div');

  $('.product .block-tabs a[href^="#"]').bind('click.smoothscroll',function (e) {
    e.preventDefault();
    var target = this.hash,
        $target = $(target);

    $('html, body').stop().animate( {
      'scrollTop': $target.offset().top-60
    }, 1000 );
  });

});

$(window).on('resize', function(){
  responsive();
  // $('.block-feature .slick-container').slick('resize');
});

// $(window).scroll(function() {
//   var scrollDistance = $(window).scrollTop();

//   // Assign active class to nav links while scolling
//   $('.product section').each(function(i) {
//       if ($(this).position().top <= scrollDistance) {
//           $('.block-tabs .nav-item.active').removeClass('active');
//           $('.block-tabs a.active').removeClass('active');
//           $('.block-tabs .nav-item').eq(i).addClass('active');
//           $('.block-tabs a').eq(i).addClass('active');
//       }
//   });
// }).scroll();

$(window).on('load', function() {
  $('#product--faq, #product--feature, #product--articles').appendTo('.shop.node-show .product > div');

  $('.product .block-tabs a[href^="#"]').bind('click.smoothscroll',function (e) {
    e.preventDefault();
    var target = this.hash,
        $target = $(target);

    $('html, body').stop().animate( {
      'scrollTop': $target.offset().top-60
    }, 1000 );
  });

  // mobile responsive
  var width = $(window).width();
  if(width > 991) {
    // tab social
    $('.social--tabs li.social-item').removeClass('swiper-slide');
    $('.block-tabs .prod-tabs li.social-item').prependTo('.block-tabs .social--tabs');

    $('.tab--container').addClass('swiper-no-swiping');
  } else {
    // tab social
    $('.social--tabs li.social-item').addClass('swiper-slide');
    $('.block-tabs .social--tabs .social-item').appendTo('.block-tabs .prod-tabs');

    // prod tabs
    $('.tab--container').removeClass('swiper-no-swiping');
    var swiper = new Swiper('.tab--container', {
      slidesPerView: 'auto',
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
    });
  }

});
